import { NavLink } from "react-router-dom";
import { BarChart3, Briefcase, CalendarDays, LayoutGrid, LogOut, Settings, Timer } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const NavItem = ({ to, icon: Icon, label, testId, end = true }) => (
  <NavLink
    to={to}
    end={end}
    data-testid={testId}
    className={({ isActive }) =>
      `inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-medium transition-colors duration-200 ${
        isActive ? "bg-[#103080] text-white" : "text-[#103080] hover:bg-[#103080]/5"
      }`
    }
  >
    <Icon size={16} />
    <span className="hidden lg:inline">{label}</span>
  </NavLink>
);

export default function AppShell({ children }) {
  const { user, logout } = useAuth();
  return (
    <div className="grain min-h-screen">
      <header className="sticky top-0 z-30 backdrop-blur-xl bg-[#FDFBF7]/85 border-b border-[#103080]/10">
        <div className="max-w-[1600px] mx-auto px-4 sm:px-8 h-16 flex items-center justify-between gap-4">
          <div className="flex items-center gap-3" data-testid="app-brand">
            <img src="/logo-mark.png" alt="Rosevale" className="h-8 w-auto" />
            <div className="leading-tight">
              <p className="font-serif-brand font-semibold text-[#103080] text-lg">Rosevale <i className="text-[#0090D0]">Hub</i></p>
            </div>
          </div>
          <nav className="flex items-center gap-1">
            <NavItem to="/" icon={CalendarDays} label="Planner" testId="nav-planner" />
            <NavItem to="/job-cards" icon={LayoutGrid} label="Job cards" testId="nav-job-cards" />
            <NavItem to="/clients" icon={Briefcase} label="Clients" testId="nav-clients" />
            <NavItem to="/workload" icon={BarChart3} label="Workload" testId="nav-workload" />
            <NavItem to="/timesheet" icon={Timer} label="Timesheet" testId="nav-timesheet" />
            <NavItem to="/settings" icon={Settings} label="Settings" testId="nav-settings" end={false} />
          </nav>
          <div className="flex items-center gap-3">
            <div className="hidden md:block text-right leading-tight">
              <p className="text-sm font-semibold text-[#103080]" data-testid="current-user-name">{user?.name}</p>
              <p className="text-xs text-[#0F172A]/50 capitalize">{user?.role}</p>
            </div>
            <button
              onClick={logout}
              data-testid="logout-button"
              aria-label="Log out"
              className="w-10 h-10 rounded-full border border-[#103080]/15 flex items-center justify-center text-[#103080] hover:bg-[#103080] hover:text-white transition-colors duration-200"
            >
              <LogOut size={16} />
            </button>
          </div>
        </div>
      </header>
      <main className="relative z-10 max-w-[1600px] mx-auto px-4 sm:px-8 py-8">{children}</main>
    </div>
  );
}
